import React, { Component } from 'react';
import { getTheme, setTheme, currentUserId, THEME_EVENT } from '../../util/theme';

// Light/dark switch: a pill with a sun on the left and a moon on the right, and a
// thumb that slides over the active one. The choice is per user — see util/theme.js.
class ThemeToggle extends Component {
  state = { theme: getTheme(currentUserId()) };

  componentDidMount() {
    window.addEventListener(THEME_EVENT, this.handleThemeChanged);
  }

  componentWillUnmount() {
    window.removeEventListener(THEME_EVENT, this.handleThemeChanged);
  }

  handleThemeChanged = (event) => {
    this.setState({ theme: event.detail.theme });
  };

  toggle = () => {
    setTheme(currentUserId(), this.state.theme === 'dark' ? 'light' : 'dark');
  };

  render() {
    if (currentUserId() === null) return null;
    const isDark = this.state.theme === 'dark';
    return (
      <button
        type="button"
        role="switch"
        aria-checked={isDark}
        aria-label="Dark mode"
        title={isDark ? 'Switch to light mode' : 'Switch to dark mode'}
        className={`theme-toggle ${isDark ? 'is-dark' : ''} ${this.props.className || ''}`}
        onClick={this.toggle}
      >
        <span className="theme-toggle-thumb" aria-hidden="true" />
        <i className="fa-sharp fa-solid fa-sun theme-toggle-icon theme-toggle-sun" aria-hidden="true" />
        <i className="fa-sharp fa-solid fa-moon theme-toggle-icon theme-toggle-moon" aria-hidden="true" />
      </button>
    );
  }
}

export default ThemeToggle;
